import * as R from "ramda";

const getPatientObj = (state) =>
  R.pathOr({}, ["admin", "resources", "patients", "data"], state);

function getFirstId(ids) {
  if (!ids) {
    return null;
  }
  if (ids.length < 1) {
    return null;
  }
  return ids[0];
}

export const hasPatientToken = (state, ownProps) => {
  const { selectedIds, record } = ownProps;
  const id = selectedIds ? getFirstId(selectedIds) : R.pathOr(null, ["id"], record);
  if (id === null) {
    return false;
  }
  const patients = getPatientObj(state);
  const patient_token = R.pathOr(null, [id, "patient_token"], patients);
  return patient_token !== null;
};
